import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

type BrandMarkProps = Omit<ComponentProps<'img'>, 'alt' | 'src'>

export default function BrandMark({ className, ...props }: BrandMarkProps) {
  return (
    <img
      {...props}
      src="/favicon.svg"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn('shrink-0 rounded-md object-contain dark:invert', className)}
    />
  )
}
